import { render, staticRenderFns } from "./role.vue?vue&type=template&id=15e4ada8&scoped=true"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"
import style0 from "./role.vue?vue&type=style&index=0&id=15e4ada8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e4ada8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/deduct_node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15e4ada8')) {
      api.createRecord('15e4ada8', component.options)
    } else {
      api.reload('15e4ada8', component.options)
    }
    module.hot.accept("./role.vue?vue&type=template&id=15e4ada8&scoped=true", function () {
      api.rerender('15e4ada8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/role.vue"
export default component.exports